import { gql } from '@apollo/client';

export const getPolicyBillsThroughBusinessPartnerQuery = gql`
  query getPolicyBillsThroughBusinessPartner(
    $pagination: PaginationInput!
    $businessPartnerId: String!
    $OrderByField: String
    $DescendingField: Boolean
    $KeywordSearch: String
  ) {
    Accounting {
      queries {
        GetPolicyBillsThroughBusinessPartnerWithPagination(
          BusinessPartnerID: $businessPartnerId
          pagination: $pagination
          OrderByField: $OrderByField
          DescendingField: $DescendingField
          KeywordSearch: $KeywordSearch
        ) {
          paging {
            totalCount
            pageSize
            pageNumber
          }
          items {
            parentBill_ParentBillCategory
            businessPartnerPolicy_Type

            linkedAmendment_Id
            linkedAmendment_AmendmentNumber
            businessPartnerPolicy_CertificateNumber
            businessPartnerPolicy_Id
            businessPartnerPolicy_PolicyName
            businessPartnerPolicy_PolicyNumber
            businessPartnerPolicy_TotalAmountReceived

            payableBill_NetPremium
            payableBill_GrossPremium
            payableBill_TotalPremium

            businessPartnerPolicy_TotalAmountReceived

            payableBill_TotalCommission
            payableBill_TaxOnCommission
            payableBill_AmountPaid
            businessPartnerPolicy_PolicyCurrency {
              Symbol
            }
          }
        }
      }
    }
  }
`;
